import { render } from "./MGSheetSlide.vue?vue&type=template&id=23929936&scoped=true"
import script from "./MGSheetSlide.vue?vue&type=script&lang=js"
export * from "./MGSheetSlide.vue?vue&type=script&lang=js"

import "./MGSheetSlide.vue?vue&type=style&index=0&id=23929936&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23929936"]])

export default __exports__